import { render, staticRenderFns } from "./FrequencyDurationV1Properties.vue?vue&type=template&id=001c600f&"
import script from "./FrequencyDurationV1Properties.vue?vue&type=script&lang=js&"
export * from "./FrequencyDurationV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports